import type { UIMessage } from '@tanstack/ai-client';

export default function isAiMessage(message: UIMessage | undefined): message is UIMessage {
  return message?.role === 'assistant';
}
